const CheckoutDOM = {
  selectors: {
    checkoutForm: "form.checkout-form",
    orderInfo: ".checkout-order-info",
    couponSection: ".checkout__coupon-section",
    paymentLoading: ".payment-info-loading",
    shippingLoading: ".shipping-info-loading",
    checkoutBtn: ".payment-checkout-btn, .payment-checkout-btn-step",
    inputCoupon: ".input-coupon-code",
    inputCouponCodeOnModal: ".coupon-code",
    couponAlert: ".checkout__coupon_alert",
  },

  replaceSections(html) {
    const temp = document.createElement("div");
    temp.innerHTML = html;

    Object.values(this.selectors).forEach((selector) => {
      if (!selector.startsWith(".")) return;
      const $new = $(temp).find(selector);
      if ($new.length && $(selector).length) {
        $(selector).html($new.html());
      }
    });
  },
};

const CheckoutUI = {
  disablePayment() {
    $(CheckoutDOM.selectors.paymentLoading).show();
    $(CheckoutDOM.selectors.checkoutBtn).prop("disabled", true);
  },

  enablePayment() {
    $(CheckoutDOM.selectors.paymentLoading).hide();
    $(CheckoutDOM.selectors.checkoutBtn).prop("disabled", false);
    document.dispatchEvent(new CustomEvent("payment-form-reloaded"));
  },

  toggle($el, condition) {
    condition ? $el.removeClass("d-none").fadeIn() : $el.addClass("d-none").fadeOut();
  },

  showNotice(messageType, message) {
    showToast(message, messageType);
  },

  dotArrayToJs(str) {
    const splittedStr = str.split(".");

    return splittedStr.length === 1 ? str : splittedStr[0] + "[" + splittedStr.splice(1).join("][") + "]";
  },

  handleValidationError(errors, $container) {
    $.each(errors, (index, item) => {
      const inputName = CheckoutUI.dotArrayToJs(index);
      let $input = $(`*[name="${inputName}"]`);

      if ($container) {
        $input = $container.find(`[name="${inputName}"]`);
      }

      if ($input.closest(".form-group").length) {
        $input.closest(".form-group").addClass("field-is-invalid");
      } else {
        $input.addClass("field-is-invalid");
      }

      if ($input.hasClass("form-control")) {
        $input.addClass("is-invalid");
        if ($input.is("select") && $input.closest(".select--arrow").length) {
          $input.closest(".select--arrow").addClass("is-invalid");
          $input.closest(".select--arrow").after(`<div class="invalid-feedback">${item}</div>`);
        } else {
          $input.after(`<div class="invalid-feedback">${item}</div>`);
        }
      }
    });

    if (errors[0]) {
      CheckoutUI.showError(errors[0]);
    }
  },

  showError(message) {
    CheckoutUI.showNotice("error", message);
  },

  showSuccess(message) {
    CheckoutUI.showNotice("success", message);
  },

  handleError(data, $container) {
    if (typeof data.errors !== "undefined" && !_.isArray(data.errors)) {
      CheckoutUI.handleValidationError(data.errors, $container);
    } else {
      if (typeof data.responseJSON !== "undefined") {
        if (typeof data.responseJSON.errors !== "undefined") {
          if (data.status === 422) {
            CheckoutUI.handleValidationError(data.responseJSON.errors, $container);
          }
        } else if (typeof data.responseJSON.message !== "undefined") {
          CheckoutUI.showError(data.responseJSON.message);
        } else {
          $.each(data.responseJSON, (index, el) => {
            $.each(el, (key, item) => {
              CheckoutUI.showError(item);
            });
          });
        }
      } else {
        CheckoutUI.showError(data.statusText);
      }
    }
  },
};

const CouponUI = {
  setLoading(isLoading) {
    $(".modal-content").toggleClass("discount-loading", isLoading);
  },
};

const CheckoutAPI = {
  updateCheckout($form, extra = {}) {
    const formData = new FormData($form.get(0));
    Object.entries(extra).forEach(([k, v]) => formData.set(k, v));

    document.dispatchEvent(new CustomEvent("checkout:shipping-calculating", { detail: extra }));

    return $.ajax({
      url: $form.data("update-url"),
      method: "POST",
      data: formData,
      processData: false,
      contentType: false,
    });
  },
  calculateShippingFee(methods) {
    let checkoutForm = $(CheckoutDOM.selectors.checkoutForm);
    const formData = new FormData(checkoutForm.get(0));

    for (let key in methods) {
      formData.set(key, methods[key]);
    }

    document.dispatchEvent(new CustomEvent("checkout:shipping-calculating", { detail: { methods } }));

    $.ajax({
      url: checkoutForm.data("update-url"),
      method: "POST",
      processData: false,
      contentType: false,
      data: formData,
      beforeSend: () => {
        CheckoutUI.disablePayment();
        $(CheckoutDOM.selectors.shippingLoading).show();
      },
      success: ({ data }) => {
        Checkout.renderCheckout(data);
      },
      complete: () => {
        CheckoutUI.enablePayment();
        $(CheckoutDOM.selectors.shippingLoading).hide();
      },
    });
  },

  applyCoupon(url, data) {
    return $.post(url, data);
  },

  reloadPage(params = "") {
    return $.get(window.location.href + params);
  },
};

const Notify = {
  show(type, message, header = "") {
    showToast(message, type);
  },
};

const Checkout = {
  init() {
    this.bindBillingAddress();
    this.bindPaymentMethod();
    this.bindTaxInfo();
    this.bindCoupon();
    this.bindAffiliateBalance();
  },

  bindBillingAddress() {
    $(document).on("change", "#billing_address_same_as_shipping_address", function () {
      CheckoutUI.toggle($(".billing-address-form-wrapper"), !this.checked);
    });
  },

  bindPaymentMethod() {
    const $form = $(CheckoutDOM.selectors.checkoutForm);

    $(document).on("change", ".list_payment_method input[name=payment_method]", (e) => {
      const method = e.target.value;

      document.dispatchEvent(new CustomEvent("checkout:payment-method-changed", { detail: { method } }));

      CheckoutAPI.calculateShippingFee({ payment_method: method });
    });
  },

  bindTaxInfo() {
    $(document).on("change", "#with_tax_information", function () {
      CheckoutUI.toggle($(".tax-information-form-wrapper"), this.checked);
    });
  },

  bindCoupon() {
    $(document).on("click", '.apply-coupon-code, [data-bb-toggle="apply-coupon-code"]', (e) => {
      e.preventDefault();
      const $btn = $(e.currentTarget);
      const isInput = $btn.hasClass("apply-coupon-code");

      const code = isInput ? $btn.closest(".coupon-wrapper").find(".coupon-code").val() : $btn.data("discount-code");

      this.processCoupon($btn, code, true);
    });

    $(document).on("click", ".remove-coupon-code", (e) => {
      e.preventDefault();
      const $btn = $(e.currentTarget);
      this.processCoupon($btn, null, false);
    });
  },

  persistAffiliateBalance() {
    const $form = $(CheckoutDOM.selectors.checkoutForm);
    const $feature = $("[data-affiliate-balance-feature]");

    if (!$form.length || !$feature.length) {
      return;
    }

    const useAffiliateBalance = $form.find('input[name="use_affiliate_balance"]').val() === "1";
    const affiliateBalanceUsed = parseFloat($form.find('input[name="affiliate_balance_used"]').val()) || 0;

    CheckoutUI.disablePayment();
    Checkout.toggleAffiliateSyncSpinner(true);

    CheckoutAPI.updateCheckout($form, {
      use_affiliate_balance: useAffiliateBalance ? 1 : 0,
      affiliate_balance_used: affiliateBalanceUsed.toFixed(2),
    })
      .done(({ data }) => {
        Checkout.renderCheckout(data);
        const finalUsed = parseFloat(data?.affiliate_balance_used) || 0;
        const finalUse = data?.use_affiliate_balance === true || finalUsed > 0;
        const $newFeature = $("[data-affiliate-balance-feature]");
        const $newInput = $newFeature.find("[data-affiliate-balance-input]");
        const $newCheckbox = $newFeature.find("[data-affiliate-balance-checkbox]");

        if ($newCheckbox.length) {
          $newCheckbox.prop("checked", finalUse);
        }

        if ($newInput.length) {
          $newInput.val(finalUse ? finalUsed.toFixed(2) : "");
        }

        Checkout.syncAffiliateBalanceFields({ preserveInput: true });
      })
      .fail((res) => {
        CheckoutUI.handleError(res);
      })
      .always(() => {
        Checkout.toggleAffiliateSyncSpinner(false);
        CheckoutUI.enablePayment();
      });
  },

  syncAffiliateBalanceFields(options = {}) {
    const { preserveInput = false } = options;
    const $feature = $("[data-affiliate-balance-feature]");

    if (!$feature.length) {
      return;
    }

    const $form = $(CheckoutDOM.selectors.checkoutForm);
    const $checkbox = $feature.find("[data-affiliate-balance-checkbox]");
    const $inputWrapper = $feature.find("[data-affiliate-balance-input-wrapper]");
    const $input = $feature.find("[data-affiliate-balance-input]");
    const affiliateBalance = parseFloat($feature.data("affiliate-balance")) || 0;

    const toNumber = (value) => {
      if (value === null || value === undefined) {
        return 0;
      }

      if (typeof value === "number") {
        return Number.isFinite(value) ? value : 0;
      }

      const cleaned = String(value)
        .replace(/[^\d.,-]/g, "")
        .replace(/,/g, "");
      const parsed = parseFloat(cleaned);

      return Number.isFinite(parsed) ? parsed : 0;
    };

    const maxUsable = Math.max(0, affiliateBalance);

    let $useHidden = $();
    let $amountHidden = $();

    if ($form.length) {
      $useHidden = $form.find('input[name="use_affiliate_balance"]');
      if (!$useHidden.length) {
        $useHidden = $('<input type="hidden" name="use_affiliate_balance" value="0">');
        $form.append($useHidden);
      }

      $amountHidden = $form.find('input[name="affiliate_balance_used"]');
      if (!$amountHidden.length) {
        $amountHidden = $('<input type="hidden" name="affiliate_balance_used" value="0">');
        $form.append($amountHidden);
      }
    }

    $input.attr("max", maxUsable.toFixed(2));

    if ($checkbox.is(":checked")) {
      $inputWrapper.removeClass("d-none");

      let currentValue = toNumber($input.val());
      if (!currentValue || currentValue <= 0) {
        currentValue = maxUsable;
      }

      if (maxUsable > 0 && currentValue > maxUsable) {
        currentValue = maxUsable;
      }

      currentValue = Math.max(0, currentValue);
      if (!preserveInput) {
        $input.val(currentValue.toFixed(2));
      }
      if ($form.length) {
        $useHidden.val("1");
        $amountHidden.val(currentValue.toFixed(2));
      }
    } else {
      $inputWrapper.addClass("d-none");
      if ($form.length) {
        $useHidden.val("0");
        $amountHidden.val("0");
      }
    }
  },

  bindAffiliateBalance() {
    $(document).on("change", "[data-affiliate-balance-checkbox]", () => {
      Checkout.syncAffiliateBalanceFields();
      Checkout.persistAffiliateBalance();
    });
    $(document).on("input", "[data-affiliate-balance-input]", function () {
      const $input = $(this);
      const max = parseFloat($input.attr("max")) || 0;
      const value = parseFloat($input.val()) || 0;

      if (value > max) {
        $input.val(max.toFixed(2));
      }

      Checkout.syncAffiliateBalanceFields({ preserveInput: true });
    });
    $(document).on("change blur", "[data-affiliate-balance-input]", function () {
      Checkout.syncAffiliateBalanceFields();
      Checkout.persistAffiliateBalance();
    });

    document.addEventListener("coupon:applied", Checkout.syncAffiliateBalanceFields);
    document.addEventListener("coupon:removed", Checkout.syncAffiliateBalanceFields);
    document.addEventListener("checkout:shipping-calculated", Checkout.syncAffiliateBalanceFields);

    // syncAffiliateBalanceFields();
    Checkout.syncAffiliateBalanceFields();
  },

  toggleAffiliateSyncSpinner(isLoading) {
    const $feature = $("[data-affiliate-balance-feature]");
    if (!$feature.length) {
      return;
    }

    let $spinner = $feature.find("[data-affiliate-balance-spinner]");
    if (!$spinner.length) {
      $spinner = $('<span class="spinner-border spinner-border-sm ms-2 d-none" role="status" aria-hidden="true" data-affiliate-balance-spinner></span>');
      $feature.find(".form-check-label").first().after($spinner);
    }

    $spinner.toggleClass("d-none", !isLoading);
    $feature.find("[data-affiliate-balance-checkbox], [data-affiliate-balance-input]").prop("disabled", isLoading);
  },

  processCoupon($btn, code, apply = true) {
    $btn.addClass("is-loading").prop("disabled", true);
    CouponUI.setLoading(true);

    const payload = {
      token: $("#checkout-token").val(),
      ...(apply ? { coupon_code: code } : {}),
    };

    CheckoutAPI.applyCoupon($btn.data("url"), payload)
      .done(({ error, message }) => {
        CheckoutAPI.reloadPage(apply ? "?applied_coupon=1" : "")
          .done((html) => {
            CheckoutDOM.replaceSections(html);
            document.dispatchEvent(new CustomEvent(apply ? "coupon:applied" : "coupon:removed"));
          })
          .always(() => {
            CouponUI.setLoading(false);
            $btn.removeClass("is-loading").prop("disabled", false);
            Notify.show(error ? "error" : "success", message);
            if (error) {
              $(CheckoutDOM.selectors.inputCoupon).val("");
              $(CheckoutDOM.selectors.inputCouponCodeOnModal).addClass("is-invalid");
            } else {
              if (apply) {
                $("#discountModal").modal("hide");
              }
              $(CheckoutDOM.selectors.inputCoupon).val(code);
              $(CheckoutDOM.selectors.inputCouponCodeOnModal).removeClass("is-invalid");
            }
          });
      })
      .fail((res) => {
        CouponUI.setLoading(false);
        $btn.removeClass("is-loading").prop("disabled", false);
        Notify.show("error", res.responseJSON?.message || "Coupon error");
        $(CheckoutDOM.selectors.inputCoupon).val("");
        $(CheckoutDOM.selectors.inputCouponCodeOnModal).addClass("is-invalid");
      });
  },

  renderCheckout(data) {
    $(".cart-item-wrapper").html(data.amount);

    if (data.products && $(".checkout-products").length) {
      $(".checkout-products").html(data.products);
    }

    if ($("[data-bb-toggle='checkout-payment-methods-area']").length) {
      $('[data-bb-toggle="checkout-payment-methods-area"]').html(data.payment_methods);
    }

    if ($("[data-bb-toggle='checkout-shipping-methods-area']").length) {
      $('[data-bb-toggle="checkout-shipping-methods-area"]').html(data.shipping_methods);
    }

    if (data.checkout_button) {
      $(CheckoutDOM.selectors.checkoutBtn).replaceWith(data.checkout_button);
    }

    if (data.checkout_warnings !== undefined) {
      const $warn = $(".checkout-warnings");
      if (!data.checkout_warnings.trim()) {
        $warn.remove();
      } else {
        $warn.length ? $warn.replaceWith(data.checkout_warnings) : $(CheckoutDOM.selectors.checkoutForm).prepend(data.checkout_warnings);
      }
    }

    document.dispatchEvent(new CustomEvent("checkout:shipping-calculated", { detail: data }));
  },
};

const CheckoutAddress = {
  init() {
    this.bindAddressSelect();
    this.bindCreateAccount();
    this.bindShippingForm();
  },

  bindAddressSelect() {
    $(document).on("change", "#address_id", function () {
      const isNew = this.value === "new";
      const isPinned = this.value === "pin";
      CheckoutUI.toggle($(".address-item-selected"), !isNew);
      CheckoutUI.toggle($(".address-form-wrapper"), isNew);
      $("[data-pinned-location]").prop("disabled", !isPinned);

      if (!isNew) {
        const $addressWrapper = $(`.address-item-wrapper[data-id=${this.value}]`);
        $(".address-item-selected").html($addressWrapper.html());

        const $addressItem = $addressWrapper.find(".address-item");

        if ($addressItem.length) {
          const $form = $(this).closest("form");
          const data = $addressItem.data();
          const fields = isPinned
            ? ["country", "state", "city", "ward", "address", "latitude", "longitude"]
            : ["name", "phone", "email", "country", "state", "city", "ward", "address", "zip_code"];

          fields.forEach((field) => {
            if (data[field] === undefined) {
              return;
            }

            const $input = $form.find(`[name="address[${field}]"]`);
            if ($input.length) {
              $input.val(data[field]);
            }

            if (field === "phone") {
              const $phoneDisplay = $form.find(`[name="address[phone_display]"]`);
              if ($phoneDisplay.length) {
                $phoneDisplay.val(data[field]);
              }
            }
          });
        }
      }
    });
  },

  bindCreateAccount() {
    $(document).on("change", "#create_account", function () {
      CheckoutUI.toggle($(".password-group"), this.checked);
    });
  },

  bindShippingForm() {
    // Standard location.js handles these now to avoid duplication and conflicts.
    // We only need this if location.js is NOT present, but since it's now integrated
    // via HasLocationFields and theme assets, we can rely on it.
    // If specific checkout logic is needed after a location update, it should be triggered via events.
  },

  updateShippingInformation($form, $input) {
    $.ajax({
      url: $("#save-shipping-information-url").val(),
      type: "POST",
      data: new FormData($form[0]),
      processData: false,
      contentType: false,
    }).done(() => {
      document.dispatchEvent(
        new CustomEvent("checkout:address-saved", {
          detail: { field: $input.attr("name") },
        }),
      );

      if (CheckoutAddress.affectsShippingFee($input.attr("name"))) {
        CheckoutUI.disablePayment();
        CheckoutAPI.updateCheckout($form)
          .done(({ data }) => Checkout.renderCheckout(data))
          .always(() => CheckoutUI.enablePayment());
      }
    });
  },

  affectsShippingFee(name) {
    return (
      /country|state|city|address/.test(name || "") &&
      !/latitude|longitude|address_note|location_manual|geocoded_address|\[(name|phone|phone_display|email)\]/.test(name || "")
    );
  },

  isPhoneWidgetSync(event) {
    const nativeEvent = event.originalEvent;

    return Boolean(nativeEvent) && !nativeEvent.isTrusted && event.target.classList.contains("js-phone-number-mask");
  },

  isMapFilling($form) {
    return $form.is("[data-map-filling]");
  },

  isValidForm($form) {
    let valid = true;
    $form.find(".form-control[required]").each((_, el) => {
      const $el = $(el);
      if (!$el.val() || $el.val() === "0") {
        valid = false;
      }
    });
    return valid && (!$form.valid || $form.valid());
  },
};

const CheckoutPickup = {
  isSelected() {
    const $checked = $("input.shipping_method_input:checked");

    return $checked.length > 0 && $checked.filter((_, el) => $(el).data("is-pickup") == 1).length === $checked.length;
  },

  setDisabled($controls, isPickup) {
    $controls.each((_, el) => {
      const $el = $(el);

      if (isPickup) {
        if (!$el.is("[data-pickup-disabled]") && !$el.prop("disabled")) {
          $el.attr("data-pickup-disabled", "1").prop("disabled", true);
        }

        return;
      }

      if ($el.is("[data-pickup-disabled]")) {
        $el.removeAttr("data-pickup-disabled").prop("disabled", false);
      }
    });
  },

  setOptional($controls, isPickup) {
    $controls.each((_, el) => {
      const $el = $(el);

      if (isPickup) {
        if ($el.is("[required]")) {
          $el.attr("data-pickup-required", "1").removeAttr("required").prop("required", false);
        }

        return;
      }

      if ($el.is("[data-pickup-required]")) {
        $el.removeAttr("data-pickup-required").attr("required", "required").prop("required", true);
      }
    });
  },

  apply() {
    const $scope = $(".customer-address-payment-form");

    if (!$scope.length) {
      return;
    }

    const isPickup = this.isSelected();

    $scope.attr("data-pickup-scope", isPickup ? 1 : 0);
    $scope.closest("[data-pickup-section]").prop("hidden", isPickup);

    $scope.find("[data-pickup-hidden]").each((_, el) => {
      const $block = $(el);

      $block.prop("hidden", isPickup);
      this.setDisabled($block.find("input, select, textarea"), isPickup);
    });

    this.setOptional($scope.find("[data-pickup-optional]").find("input, select, textarea"), isPickup);

    this.toggleAddressForm($scope, isPickup || ($("#address_id").val() || "new") === "new");

    $("[data-checkout-pickup-card]").prop("hidden", !isPickup);

    document.dispatchEvent(new CustomEvent("checkout:pickup-toggled", { detail: { isPickup } }));
  },

  // CheckoutUI.toggle fades the wrapper, leaving an inline display that would outrank d-none.
  toggleAddressForm($scope, shouldShow) {
    const $addressForm = $scope.find(".address-form-wrapper");

    if (shouldShow === $addressForm.hasClass("d-none")) {
      $addressForm.stop(true, true).css("display", "").toggleClass("d-none", !shouldShow);
    }
  },

  // Listens in the capture phase: the address fields have to be enabled again before the checkout
  // handlers, bound later on the document, serialize the form and lose them.
  init() {
    this.apply();

    document.addEventListener(
      "change",
      (event) => {
        if (event.target.matches("input.shipping_method_input, #address_id")) {
          this.apply();
        }
      },
      true,
    );

    document.addEventListener("checkout:shipping-calculated", () => this.apply());
  },
};

const CheckoutFormHandler = {
  init() {
    const $checkoutForm = $(CheckoutDOM.selectors.checkoutForm);
    const shippingForm = "#main-checkout-product-info";
    const customerShippingAddressForm = ".customer-address-payment-form .address-form-wrapper";
    const customerBillingAddressForm = ".customer-billing-address-form";
    const customerTaxInformationForm = ".customer-tax-information-form";

    if ($checkoutForm.find(".list-customer-address").length) {
      CheckoutAPI.calculateShippingFee();
    }

    $(document).on("change", "input.shipping_method_input", (event) => {
      const data = {};
      const $this = $(event.currentTarget);

      if ($this.closest(".checkout-products-marketplace").length) {
        const shippingMethods = $(shippingForm).find("input.shipping_method_input");

        if (shippingMethods.length) {
          shippingMethods.map((i, shm) => {
            const val = $(shm).filter(":checked").val();
            const sId = $(shm).data("id");

            if (val) {
              data[`shipping_method[${sId}]`] = val;
              data[`shipping_option[${sId}]`] = $(shm).data("option");
            }
          });
        }
      } else {
        $("input[name=shipping_option]").val($this.data("option"));
        $(".mobile-total").text("...");

        const data = {
          shipping_method: $this.val(),
          shipping_option: $this.data("option"),
          payment_method: "",
          address: {
            address_id: $("#address_id").val(),
          },
        };

        const paymentMethod = $(document).find("input[name=payment_method]:checked").first();
        if (paymentMethod.length) {
          data["payment_method"] = paymentMethod.val();
        }
      }

      document.dispatchEvent(
        new CustomEvent("checkout:shipping-method-changed", {
          detail: { method: $this.val(), option: $this.data("option") },
        }),
      );

      CheckoutAPI.calculateShippingFee(data);
    });

    document.addEventListener("coupon:applied", function () {
      const paymentMethod = $(document).find("input[name=payment_method]:checked").first();
      CheckoutAPI.calculateShippingFee({ payment_method: paymentMethod.val() });
    });

    document.addEventListener("coupon:removed", function () {
      const paymentMethod = $(document).find("input[name=payment_method]:checked").first();
      CheckoutAPI.calculateShippingFee({ payment_method: paymentMethod.val() });
    });

    const validatedFormFields = () => {
      const addressId = $("#address_id").val();

      if (addressId && addressId !== "new") {
        return true;
      }

      let validated = true;

      $.each($(document).find(".form-control[required]"), (index, el) => {
        if (!$(el).val() || $(el).val() === "null") {
          validated = false;
        }
      });

      return validated;
    };

    const saveShippingInformation = ($form, field) =>
      $.ajax({
        type: "POST",
        cache: false,
        url: $("#save-shipping-information-url").val(),
        data: new FormData($form[0]),
        contentType: false,
        processData: false,
      }).done(({ error }) => {
        if (!error) {
          document.dispatchEvent(
            new CustomEvent("checkout:address-saved", {
              detail: { field },
            }),
          );
        }
      });

    const onChangeShippingForm = (event, options = {}) => {
      const _self = $(event.currentTarget);
      const changedId = _self.attr("id");

      if (options.isInitial || CheckoutAddress.isPhoneWidgetSync(event) || CheckoutAddress.isMapFilling(_self.closest("form"))) {
        return;
      }

      const locationFields = ["address_country", "address_state", "address_city"];
      if (locationFields.includes(changedId)) {
        if (changedId === "address_country") {
          CheckoutAPI.calculateShippingFee();
          return;
        }
        const $state = $("#address_state");
        const $city = $("#address_city");
        if ($state.length && !$state.val()) {
          return;
        }
        if ($city.length && !$city.val() && changedId !== "address_state") {
          return;
        }
        // Thêm cái này để tránh khi user thay đổi state thì phải chọn lại city mới đi xuống phía dưới
        if (changedId === "address_state" && $city.length && $city.val()) {
          return;
        }
      }

      _self.closest(".form-group").find(".text-danger").remove();
      const $form = _self.closest("form");

      if (validatedFormFields() && $form.valid && $form.valid()) {
        const field = $(event.target).prop("name");

        saveShippingInformation($form, field)
          .done(({ error }) => {
            if (!error && CheckoutAddress.affectsShippingFee(field)) {
              CheckoutAPI.calculateShippingFee();
            }
          })
          .fail((response) => {
            CheckoutUI.handleError(response, $form);
          });
      }
    };

    document.addEventListener("checkout:location-confirmed", () => {
      const $form = $(CheckoutDOM.selectors.checkoutForm);

      if (!validatedFormFields() || ($form.valid && !$form.valid())) {
        return;
      }

      CheckoutUI.disablePayment();

      saveShippingInformation($form, "address[address_id]")
        .done(({ error, message }) => {
          if (error) {
            CheckoutUI.enablePayment();
            CheckoutUI.showError(message);

            return;
          }

          CheckoutAPI.calculateShippingFee();
        })
        .fail((response) => {
          CheckoutUI.enablePayment();
          CheckoutUI.handleError(response, $form);

          const errors = response.responseJSON && response.responseJSON.errors;
          const firstError = errors && Object.values(errors)[0];

          if (firstError) {
            CheckoutUI.showError(Array.isArray(firstError) ? firstError[0] : firstError);
          }
        });
    });

    $(document).on("change", "#address_country, #address_state, #address_city, #address_zip_code", (event) => {
      const _self = $(event.currentTarget);
      const $form = _self.closest("form");

      if (CheckoutAddress.isMapFilling($form)) {
        return;
      }

      _self.valid();
      const changedId = _self.attr("id");

      if (changedId !== "address_country") {
        const $state = $form.find("#address_state");
        const $city = $form.find("#address_city");
        if ($state.length && !$state.val()) {
          return;
        }
        if ($city.length && !$city.val() && changedId !== "address_state") {
          return;
        }
      }

      $.ajax({
        type: "POST",
        cache: false,
        url: $("#update-checkout-tax-url").val(),
        data: new FormData($form[0]),
        contentType: false,
        processData: false,
        success: ({ data }) => {
          $(".cart-item-wrapper").html(data.amount);

          document.dispatchEvent(new CustomEvent("checkout:tax-updated", { detail: { data } }));
        },
        error: (response) => {
          CheckoutUI.handleError(response, $form);
        },
      });
    });

    $(document).on("change", `${customerShippingAddressForm} .form-control`, (event, options) => {
      onChangeShippingForm(event, options);
    });

    $(document).on("change", ".list-customer-address .form-control", (event, options) => {
      onChangeShippingForm(event, options);
    });

    $(document).on("change", `${customerBillingAddressForm} #billing_address_same_as_shipping_address`, (event) => {
      const _self = $(event.currentTarget);
      const val = _self.find(":selected").val();
      if (val) {
        $(".billing-address-form-wrapper").hide();
      } else {
        $(".billing-address-form-wrapper").show();
      }
    });

    $(document).on("change", `${customerTaxInformationForm} #with_tax_information`, (event) => {
      const _self = $(event.currentTarget);

      $(".tax-information-form-wrapper").toggle(_self.is(":checked"));
    });

    const $addressId = $("#address_id");

    if ($addressId.length && $addressId.val() && $addressId.val() !== "new") {
      $addressId.trigger("change", [{ isInitial: true }]);
    }
  },
};

$(document).on("submit", CheckoutDOM.selectors.checkoutForm, function () {
  const $button = $(".payment-checkout-btn");

  if (!$button.length) return;

  if ($button.data("original-html") === undefined) {
    $button.data("original-html", $button.html());
  }

  $button.prop("disabled", true).html(`<span class="spinner-border spinner-border-sm me-2" role="status"></span> ${$button.data("processing-text")}`);
});

$(document).on("change", ".checkout-proof-input", function () {
  const $label = $(this).siblings(".checkout-proof-label");

  if (this.files && this.files.length > 0) {
    $label.find(".checkout-proof-filename").text(this.files[0].name);
    $label.addClass("has-file");
  } else {
    $label.find(".checkout-proof-filename").text("");
    $label.removeClass("has-file");
  }
});

$(function () {
  Checkout.init();
  CheckoutAddress.init();
  CheckoutFormHandler.init();
  CheckoutPickup.init();
});
